/**
 * External services (all keyless; see docs/RESEARCH notes).
 * Fair-use community servers — self-host when traffic grows.
 */
export const MAP_STYLE_URL = 'https://tiles.openfreemap.org/styles/liberty'
export const TERRAIN_TILES = 'https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png'
export const VALHALLA_URL = 'https://valhalla1.openstreetmap.de'
export const PHOTON_URL = 'https://photon.komoot.io'
export const OVERPASS_URL = 'https://overpass-api.de/api/interpreter'
export const OPEN_METEO_URL = 'https://api.open-meteo.com/v1/forecast'

export const MAP_ATTRIBUTION =
  '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> · <a href="https://openfreemap.org">OpenFreeMap</a> · Terrain: <a href="https://registry.opendata.aws/terrain-tiles/">Tilezen/AWS</a> · Routing: <a href="https://gis-ops.com/global-open-valhalla-server-online/">FOSSGIS Valhalla</a> · Weather: <a href="https://open-meteo.com/">Open-Meteo</a>'
